<template>
  <div class="column">
    <div class="row q-pt-md q-pb-xs">
      <span class="text-weight-bold text-grey-10">{{ groupDate }}</span>
      <QSpace />
      <span class="text-weight-bold text-grey-10">
        TOTAL: {{ totalBalance | currency }}
      </span>
    </div>
    <div
      :class="['row q-py-md items-start', { 'bdr-t-grey-4': index }]"
      v-for="(transaction, index) in transactions"
      :key="index"
    >
      <div
        class="bg-primary-pale rounded-borders-half q-pa-sm row items-center q-mr-md"
        v-if="icon"
      >
        <QIcon :name="icon" color="primary" size="16px" />
      </div>
      <div class="col">
        <p class="text-body text-weight-medium" style="margin-bottom: 2px;">
          {{ transaction.label }}
        </p>
        <span>
          {{ transaction.date | parseDate }}
        </span>
      </div>
      <div
        :class="[
          'rounded-borders text-weight-medium',
          {
            'q-pa-sm bg-positive-light text-positive':
              transaction.transactionAmount > 0
          }
        ]"
      >
        {{ transaction.transactionAmount | currency }}
      </div>
    </div>
  </div>
</template>

<script>
import { QSpace, QIcon } from 'quasar';

export default {
  name: 'BudgetTransactions',
  props: {
    groupDate: String,
    totalBalance: Number,
    icon: String,
    transactions: {
      type: Array,
      default: () => []
    }
  },
  components: {
    QSpace,
    QIcon
  }
};
</script>
